module.exports = __webpack_public_path__ + "static/img/2.9e4395c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/UltralowTemperature/R14/2.jpg
// module id = QEqB
// module chunks = 1